.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  gap: 6px;
  border: 1px solid var(--neutral-600, #d9d9d9);
  border-radius: var(--border-radius-sm, 4px);
  background: transparent;
  color: var(--neutral-600, #0E0E0E);
  cursor: pointer;
  transition: background-color 200ms ease, color 200ms ease;
}
.button:hover {
  background: var(--neutral-100, #F5F5F5);
}
.button.active {
  background: var(--neutral-600, #0E0E0E);
  color: #FFFFFF;
}
.button.active svg {
  fill: #FFFFFF;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvSGVhZGVyL2NvbXBvbmVudHMvQ29sbGFwc2VIZWFkZXJCdXR0b24iLCJzb3VyY2VzIjpbIkNvbGxhcHNlSGVhZGVyQnV0dG9uLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBRUE7RUFDQTtFQUNBO0VBQ0E7RUFFQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi5idXR0b24ge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblxuICB3aWR0aDogMzZweDtcbiAgaGVpZ2h0OiAzNnB4O1xuICBwYWRkaW5nOiAwO1xuICBnYXA6IDZweDtcblxuICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1uZXV0cmFsLTYwMCwgI2Q5ZDlkOSk7XG4gIGJvcmRlci1yYWRpdXM6IHZhcigtLWJvcmRlci1yYWRpdXMtc20sIDRweCk7XG4gIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xuICBjb2xvcjogdmFyKC0tbmV1dHJhbC02MDAsICMwRTBFMEUpO1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIHRyYW5zaXRpb246IGJhY2tncm91bmQtY29sb3IgMjAwbXMgZWFzZSwgY29sb3IgMjAwbXMgZWFzZTtcblxuICAmOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kOiB2YXIoLS1uZXV0cmFsLTEwMCwgI0Y1RjVGNSk7XG4gIH1cblxuICAmLmFjdGl2ZSB7XG4gICAgYmFja2dyb3VuZDogdmFyKC0tbmV1dHJhbC02MDAsICMwRTBFMEUpO1xuICAgIGNvbG9yOiAjRkZGRkZGO1xuXG4gICAgc3ZnIHtcbiAgICAgIGZpbGw6ICNGRkZGRkY7XG4gICAgfVxuICB9XG59Il19 */